import { inputTags, textInputTypes } from './enums';
import { activeElement } from './cable_ready'; // Indicates if the passed element is considered a text input.
//

export var isTextInput = function isTextInput(element) {
  return inputTags[element.tagName] && textInputTypes[element.type];
}; // Assigns focus to the appropriate element... preferring the explicitly passed selector
//
// * selector - a CSS selector for the element that should have focus
//

export var assignFocus = function assignFocus(selector) {
  var element = selector && selector.nodeType === Node.ELEMENT_NODE ? selector : document.querySelector(selector);
  var focusElement = element || activeElement;
  if (focusElement && focusElement.focus) focusElement.focus();
}; // Dispatches an event on the passed element
//
// * element - the element
// * name - the name of the event
// * detail - the event detail
//

export var dispatch = function dispatch(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = {
    bubbles: true,
    cancelable: true,
    detail: detail
  };
  var evt = new CustomEvent(name, init);
  element.dispatchEvent(evt);
  if (window.jQuery) window.jQuery(element).trigger(name, detail);
}; // Accepts an xPath query and returns the element found at that position in the DOM
//

export var xpathToElement = function xpathToElement(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}; // Return an array with the class names to be used
//
// * names - could be a string or an array of strings for multiple classes.
//

export var getClassNames = function getClassNames(names) {
  return Array(names).flat();
};